import React from 'react';
import { Award, Crown, Star } from 'lucide-react';

const BADGE_STYLES = {
  founding: {
    bg: 'bg-gradient-to-r from-[#D4AF37] to-[#C9A030]',
    text: 'text-white',
    icon: Crown,
    label: 'Founding Provider',
    ring: 'ring-[#D4AF37]/30',
  },
  early: {
    bg: 'bg-gradient-to-r from-purple-600 to-purple-500',
    text: 'text-white',
    icon: Award,
    label: 'Early Provider',
    ring: 'ring-purple-500/30',
  },
  top_rated: {
    bg: 'bg-gradient-to-r from-emerald-600 to-teal-500',
    text: 'text-white',
    icon: Star,
    label: 'Top Rated',
    ring: 'ring-emerald-500/30',
  },
};

export function ProviderBadge({ badge, size = 'sm', className = '' }) {
  if (!badge || !BADGE_STYLES[badge]) return null;
  const style = BADGE_STYLES[badge];
  const Icon = style.icon;

  if (size === 'xs') {
    return (
      <span
        className={`inline-flex items-center gap-1 px-1.5 py-1 rounded-full text-[10px] font-semibold ring-1 shadow-sm backdrop-blur-sm ${style.bg} ${style.text} ${style.ring} ${className}`}
        data-testid={`provider-badge-${badge}`}
        title={style.label}
      >
        <Icon className="h-3 w-3" />
      </span>
    );
  }

  if (size === 'lg') {
    return (
      <span
        className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-sm font-semibold ring-2 ${style.bg} ${style.text} ${style.ring} ${className}`}
        data-testid={`provider-badge-${badge}`}
      >
        <Icon className="h-4 w-4" />
        {style.label}
      </span>
    );
  }

  // Default: sm
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ring-1 ${style.bg} ${style.text} ${style.ring} ${className}`}
      data-testid={`provider-badge-${badge}`}
    >
      <Icon className="h-3 w-3" />
      {style.label}
    </span>
  );
}
